import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import obj from '@/constants';

import Home from './views/Home.vue';
import Product from './views/Product.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/products',
      name: 'products',
      component: () =>
        import(/* webpackChunkName: "products" */ './views/Products.vue'),
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: () =>
        import(/* webpackChunkName: "contacts" */ './views/Contacts.vue'),
    },
    {
      path: '/about',
      name: 'about',
      component: () =>
        import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      path: '/product/:id',
      component: Product,
      beforeEnter: (to, from, next) => {
        if (!store.getters.products) {
          store.dispatch('getProducts').then(() => {
            store.commit('setCurrentProducts', to.params.id);
            next();
          });
        } else {
          store.commit('setCurrentProducts', to.params.id);
          next();
        }
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.query.lang && obj.LANGUAGES.some(el => el === to.query.lang)) {
    store.commit('setLang', to.query.lang);
  } else {
    store.commit('setLang', 'en');
  }
  next();
});

router.beforeEach((to, from, next) => {
  if (from.query.lang && !to.query.lang) {
    next(Object.assign({}, to, { query: from.query }));
  } else {
    next();
  }
});

export default router;
